import apiService from 'services/apiService';

const baseUrl = `${window._env_.ACTIVITY_API_DOMAIN}`;

const getTimelineActivities = ({ limit, normalizedCases, sort, type }) => {
  const url = `${baseUrl}/activities`;
  return apiService.get(url, { params: { limit, normalizedCases, sort, type } });
};

export { getTimelineActivities };
